const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001/" //|| "http://localhost:8888/" 
// const apiUrl = "http://localhost:5000/"
// console.log("apiUrl: ", apiUrl);

module.exports = {
    apiUrl
};